import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dashboard-header',
  templateUrl: './dashboard-header.component.html',
  styleUrls: ['./dashboard-header.component.scss']
})

export class DashboardHeaderComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {}

  menus = [
    {title:'Main',link: '/user/dashboard/main'},
    {title:'Web Development',link: '/user/dashboard/web'},
    {title:'Photography',link: '/user/dashboard/photography'},
    {title:'Message',link: '/user/dashboard/message'},
    {title:'User',link: '/user/dashboard/user'}
  ]

}